import { memecore } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createMemeCoreChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createMemeCoreChainCustom({
    client: createClient({
      chain: memecore,
      httpRpcs: memeCoreHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'MemeCoreScan',
      baseUrl: 'https://memecorescan.io',
      chainId: 4352,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateMemeCoreChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createMemeCoreChainCustom = ({
  client,
  explorer,
}: CreateMemeCoreChainCustomParameters): Chain => ({
  id: 4352,
  network: 'meme-core',
  name: 'MemeCore',
  nativeToken: {
    name: 'MemeCore',
    symbol: 'M',
    decimals: 18,
    currency: {
      symbol: 'M',
      type: 'CryptoCurrency',
      id: 'memecore',
      name: 'MemeCore',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x653e645e3d81a72e71328bc01a04002945e3ef7a',
  ]),
  explorer,
  client,
  blockTime: 7000,
  coingeckoId: 'memecore',
  defillamaId: undefined,
})

export const memeCoreHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.memecore.net',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const memeCoreWebsocketRpcUrls: string[] = ['wss://ws.memecore.net']
